import { TriangleAlert } from 'lucide-react';
import Showdown from 'showdown';
import styled from 'styled-components';

import Banner from '@/components/Banner/Banner';
import { useMessage } from '@/messages';

const covert = new Showdown.Converter({
  tables: true,
  literalMidWordUnderscores: true,
  simpleLineBreaks: true,
  disableForced4SpacesIndentedSublists: true,
});

export const NaverCafeSourceGuide = () => {
  const m = useMessage();
  return (
    <Banner
      icon={<TriangleAlert className="size-4" />}
      flow="vertical"
      title={m.scraping('NAVER_CAFE_SOURCE_GUIDE_TITLE')}
      variant="warning"
      desc={
        <MarkdownContentStyle
          dangerouslySetInnerHTML={{
            __html: covert.makeHtml(
              m.scraping('NAVER_CAFE_SOURCE_GUIDE_DESC') as string,
            ),
          }}
        />
      }
    />
  );
};

const MarkdownContentStyle = styled.div`
  font-size: 12px;
  line-height: 1.6;
  p {
    margin: 0;
    margin-bottom: 4px;
  }
  ol,
  ul {
    padding-left: 0;
    margin: 0;
  }
  ol {
    list-style: decimal;
    margin-left: 2px;
  }
  li {
    margin-bottom: 2px;
    margin-left: 12px;
  }

  li:last-child {
    margin-bottom: 0;
  }

  hr {
    margin: 20px 0;
  }

  hr:first-child {
    margin-top: 0;
  }
`;
